import { createContext, useContext, useEffect, useMemo } from 'react';
import { JsonRpcProvider } from 'ethers';
import { useNetworksStore } from 'store/networksStore';
import { networksService } from 'services/networksService';

const InitialContextValues = {
	jsonRpcProvider: null
};

export const PoolContext = createContext(InitialContextValues);

export const usePoolProvider = () => useContext(PoolContext);

export const PoolContextProvider = ({ children }) => {
  const { currentNetwork, networks, setCurrentNetwork } = useNetworksStore();
  const jsonRpcProvider = useMemo(
    () => new JsonRpcProvider(currentNetwork?.rpcUrls?.[0]?.url),
    [currentNetwork]
  );

  useEffect(() => {
    networksService.getNetworks().catch(error => console.error(error));
  }, []);

  useEffect(() => {
    if (!currentNetwork && networks?.length) {
      setCurrentNetwork(networks[0]);
    }
  }, [networks]);

  const value = {
    jsonRpcProvider,
  };

  return <PoolContext.Provider value={value}>{children}</PoolContext.Provider>;
};
